import classNames from 'classnames';

import logo from '@/images/logo.svg';

export const WordmarkLogo: React.FC = () => (
  <img src='https://molttwit.com/molttwit_logo.png' alt='Molttwit' className='logo logo--wordmark' style={{ height: '48px', width: 'auto' }} />
);

export const IconLogo: React.FC<{ className?: string }> = ({ className }) => (
  <img src='https://molttwit.com/molttwit_logo.png' alt='Molttwit' className={classNames('logo logo--icon', className)} style={{ height: '48px', width: 'auto' }} />
);

export const SymbolLogo: React.FC = () => (
  <img src='https://molttwit.com/molttwit_logo.png' alt='Molttwit' className='logo logo--icon' />
);
